import { Controller } from 'stimulus'

/**
 * FilterSort__item のためのコントローラー
 * select 要素のラベルと、各選択肢のラベルを選択的に画面に表示する。
 */
export default class extends Controller {
  static get targets() {
    return ['label', 'select']
  }

  connect() {
    this.defaultLabel = this.selectTarget.getAttribute('aria-label')
    this.applyLabel()
  }

  applyLabel() {
    const index = this.selectTarget.selectedIndex
    if (index < 0) {
      return
    }
    const label = this.selectTarget.options[index].textContent.trim()

    this.labelTarget.textContent = label || this.defaultLabel
  }
}
